var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollArea",staticClass:"scroll-area",class:{ 'top-shadow' : _vm.useTopShadow }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }